import {ActivityLoansState} from "@/store/modules/loans/index";
import {initialState} from '@/store/modules/processes'
import {MutationTree} from 'vuex'

export const mutations: MutationTree<ActivityLoansState> = {

    setActivityLoans: (state, processTypes: any[]) => {
        state.activityLoans = processTypes
        state.isEmpty = false
    },

    resetState: (state) => {
        state = Object.assign(state, initialState())
    }
}
